
import Magicpen from "../../../assets/duotone/Magicpen.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MagicpenIcon({ className, dataTestid = "MagicpenIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Magicpen data-testid={dataTestid} className={classes} {...rest} />
  );
}
